export default "<password-set encrypted-token=\"$ctrl.encryptedToken\"></password-set>\n";